export default __webpack_public_path__ + "static/media/subcategory_car_2.d8a17e9a.png";